import { render } from "./Error_Dialog.vue?vue&type=template&id=004cbbfb&scoped=true"
import script from "./Error_Dialog.vue?vue&type=script&lang=js"
export * from "./Error_Dialog.vue?vue&type=script&lang=js"

import "./Error_Dialog.vue?vue&type=style&index=0&id=004cbbfb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004cbbfb"]])

export default __exports__